module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "dawnSelect__main-wrapper"
    }
  }, [(_vm.helptipBody && _vm.isOpen || _vm.helptipBody && _vm.error) ? _c('ed-input-tooltip', {
    class: {
      "error-message": _vm.error
    },
    attrs: {
      "helptipHeader": _vm.helptipHeader,
      "helptipBody": _vm.helptipBody,
      "errorTip": _vm.error
    }
  }) : _vm._e(), (_vm.fieldLabel) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.fieldLabel)), (_vm.required) ? _c('span', [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "dawnSelect",
    class: {
      'dawnSelect--active form-field--active': _vm.isOpen, 'dawnSelect--disabled': _vm.disabled, 'dawnSelect--above': _vm.isAbove
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex
    },
    on: {
      "focus": function($event) {
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      }
    }
  }, [_vm._t("caret", [_c('div', {
    staticClass: "dawnSelect__select",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle()
      }
    }
  })], {
    toggle: _vm.toggle
  }), _vm._t("clear", null, {
    search: _vm.search
  }), _c('div', {
    ref: "tags",
    staticClass: "dawnSelect__tags"
  }, [(_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_c('strong', {
    staticClass: "dawnSelect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })] : _vm._e(), _c('transition', {
    attrs: {
      "name": "dawnSelect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dawnSelect__spinner"
  })])], 2), (_vm.searchable) ? _c('input', _vm._b({
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      value: (_vm.autofocus),
      expression: "autofocus",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "search",
    staticClass: "dawnSelect__input",
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.isOpen ? _vm.search : _vm.currentOptionLabel
    },
    on: {
      "focus": [function($event) {
        _vm.focused = true
      }, function($event) {
        $event.preventDefault();
        _vm.activate()
      }],
      "blur": [function($event) {
        _vm.focused = false
      }, function($event) {
        $event.preventDefault();
        _vm.deactivate()
      }],
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }, 'input', _vm.$props, false)) : _vm._e(), (!_vm.searchable) ? _c('span', {
    staticClass: "dawnSelect__single",
    domProps: {
      "textContent": _vm._s(_vm.currentOptionLabel)
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }) : _vm._e()], 2), _c('transition', {
    attrs: {
      "name": "dawnSelect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "dawnSelect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "dawnSelect__content",
    style: (_vm.contentStyle)
  }, [_vm._t("beforeList"), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "dawnSelect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected option to select another.")])], 2)]) : _vm._e(), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "dawnSelect__element"
    }, [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "dawnSelect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "touchstart": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.handleTouchStartStop(index, option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "dawnSelect__option dawnSelect__option--disabled",
      class: _vm.optionHighlight(index, option)
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()])
  }) : _vm._e(), _vm._t("afterList")], 2)])])], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValue.length > 0),
      expression: "visibleValue.length > 0"
    }],
    staticClass: "dawnSelect__tags-wrap"
  }, [_vm._l((_vm.visibleValue), function(option) {
    return [_vm._t("tag", [_c('span', {
      staticClass: "dawnSelect__tag-icon"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _c('i', {
      staticClass: "dawnSelect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e51c4f1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edSelect/index.vue
// module id = PGGg
// module chunks = 13 14